import * as types from '../../../lib/actionTypes.es6';

export var initialState = {
  list: [],
  loading: false,
  error: null,

  current: null,
  currentLoading: false,
  currentError: null,

  creating: false,
  created: null,
  createError: null,

  updating: false,
  updated: null,
  updateError: null,

  deleting: false,
  deleted: null,
  deleteError: null,
};

export default function organizationsReducer(state, action) {
  if (state === undefined) {
    state = initialState;
  }
  switch (action.type) {
    case types.GET_ORGANIZATIONS_REQUEST:
      return Object.assign({}, state, { loading: true, error: null, list: [] });
    case types.GET_ORGANIZATIONS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        list: action.payload,
      });
    case types.GET_ORGANIZATIONS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
      });

    case types.GET_ORGANIZATION_REQUEST:
      return Object.assign({}, state, {
        currentLoading: true,
        currentError: null,
        current: null,
      });
    case types.GET_ORGANIZATION_SUCCESS:
      return Object.assign({}, state, {
        currentLoading: false,
        current: action.payload,
      });
    case types.GET_ORGANIZATION_FAILURE:
      return Object.assign({}, state, {
        currentLoading: false,
        currentError: action.payload,
      });

    case types.CREATE_ORGANIZATION_REQUEST:
      return Object.assign({}, state, {
        creating: true,
        created: null,
        createError: null,
      });
    case types.CREATE_ORGANIZATION_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        created: action.payload,
      });
    case types.CREATE_ORGANIZATION_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        createError: action.payload,
      });
    case types.RESET_CREATE_ORGANIZATION_SUCCESS:
      return Object.assign({}, state, { created: null });
    case types.RESET_CREATE_ORGANIZATION_ERROR:
      return Object.assign({}, state, { createError: null });

    case types.UPDATE_ORGANIZATION_REQUEST:
      return Object.assign({}, state, {
        updating: true,
        updated: null,
        updateError: null,
      });
    case types.UPDATE_ORGANIZATION_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        updated: action.payload,
        current: action.payload,
      });
    case types.UPDATE_ORGANIZATION_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        updateError: action.payload,
      });
    case types.RESET_UPDATE_ORGANIZATION_SUCCESS:
      return Object.assign({}, state, { updated: null });
    case types.RESET_UPDATE_ORGANIZATION_ERROR:
      return Object.assign({}, state, { updateError: null });

    case types.DELETE_ORGANIZATION_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
        deleted: null,
        deleteError: null,
      });
    case types.DELETE_ORGANIZATION_SUCCESS:
      return Object.assign({}, state, { deleting: false, deleted: true });
    case types.DELETE_ORGANIZATION_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        deleteError: action.payload,
      });
    case types.RESET_DELETE_ORGANIZATION_SUCCESS:
      return Object.assign({}, state, { deleted: null });
    case types.RESET_DELETE_ORGANIZATION_ERROR:
      return Object.assign({}, state, { deleteError: null });

    default:
      return state;
  }
}
